import axios from "axios";
import toast from 'react-hot-toast'
import translatedMessages, {defaultMessages} from "../components/Utils/translatedMessages";
import { useCookies } from "./api";

export const defaultBackend = process.env.REACT_APP_URL_PLATESYS


const defaultOptions = {
    baseURL: defaultBackend,
    timeout: 30000, // No direct timeout support in fetch()
    credentials: "include"
};

export const apiFetch = async (endpoint, options = {}) => {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), defaultOptions.timeout);
    const token = localStorage.getItem('token')
    const extraHeaders = useCookies === 'false' ? {Authorization: `Bearer ${token}`} : {}

    try {
        const response = await fetch(defaultOptions.baseURL + endpoint, {
            signal: controller.signal,
            headers: { ...defaultOptions.headers, ...options.headers, ...extraHeaders }, // Merge headers
            credentials: "include",
            ...options,
        });
        clearTimeout(id); // Stop timeout if request succeeds
        return response;
    } catch (error) {
        console.error("Fetch error:", error);
        throw error;
    }
};